import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import GrupoPessoaService from "./grupoPessoaService"
import FormList from 'base/FormList'

export default function GrupoPessoaList() {

    const [service] = useState(() => new GrupoPessoaService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_grup',
        dsName: 'descricao_grup',
        mainField: { name: 'descricao_grup', label: 'Descrição' },
        advFields: [
            { name: 'codigo_grup', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_grup', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_grup" sortable header="Descrição"></Column>
            <Column field="meta.descricao_tipe" sortable header="Tipo"></Column>
        </FormList >
    )
}
